const API = "/api";

export const trackCta = (button, club = "") => {
  try { sessionStorage.setItem("lead_source", button); } catch {}
  const payload = JSON.stringify({ button, club, page: window.location.pathname });
  try {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(`${API}/track/cta`, new Blob([payload], { type: "application/json" }));
    } else {
      fetch(`${API}/track/cta`, { method: "POST", headers: { "Content-Type": "application/json" }, body: payload, keepalive: true });
    }
  } catch {}
};

export const getLeadSource = () => {
  try { return sessionStorage.getItem("lead_source") || ""; } catch { return ""; }
};

export const clearLeadSource = () => {
  try { sessionStorage.removeItem("lead_source"); } catch {}
};

export const fbTrack = (event, eventId) => {
  try {
    if (window.fbq) {
      if (eventId) window.fbq("track", event, {}, { eventID: eventId });
      else window.fbq("track", event);
    }
  } catch {}
};

export const newEventId = () => {
  try { return crypto.randomUUID(); } catch { return `ev-${Date.now()}-${Math.random().toString(36).slice(2)}`; }
};

export const toE164PT = (phone) => {
  let d = String(phone || "").replace(/\D+/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  if (!d.startsWith("351")) {
    if (d.startsWith("0")) d = d.slice(1);
    d = "351" + d;
  }
  return d.length > 3 ? `+${d}` : "";
};
